import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import AuthContext from '../../store/Auth/AuthContext';
import { appConfig } from '../../config';


// Define the useStyles return type
const useStyles = makeStyles({
  root: {
    display: 'block !important',
  },
  googleBtnWrapper: {
    display: 'block !important',
    height: '44px',
    margin: '8px 0',
    maxWidth: '480px',
    position: 'relative',
  },
  extLoginContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const GoogleLogin: React.FC = () => {
    const classes = useStyles();
    const smallMobile = useMediaQuery('(max-width: 375px)');
    const { GoogleLogin: Login } = useContext<any>(AuthContext);

    useEffect(() => {
        async function fetchData() {
        await window.google?.accounts.id.initialize({
            client_id: appConfig.google.clientId, // Assuming REACT_APP_GOOGLE_CLIENT_ID is always defined
            callback: handleCredentialResponse,
            theme: 'filled_blue',
            text: 'continue_with',
            shape: 'circle',
        });

        await window.google?.accounts.id.renderButton(document.getElementById('googleContainer')!, {
            size: smallMobile ? 'small' : 'large',
            width: smallMobile ? '240px' : '280px',
            text: 'continue_with',
        });
        }
        fetchData();
    }, []);

    const handleCredentialResponse = async (response: any) => {
        const token = response?.credential;
        Login(token);
    };

    return (
        <div className={classes.extLoginContainer}>
        <div className={classes.googleBtnWrapper} style={{ width: smallMobile ? '240px' : '280px' }}>
            <div id="googleContainer"></div>
        </div>
        </div>
    );
};

export default GoogleLogin;
